









import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
    import {formatDate, formatPrice} from "@/utils/formatters";

    declare const $: any;

    @Component({})
    export default class ObjektiCard2TabStalci extends Vue {
        @Prop({default: false}) isBusyLoadingRacks!: boolean;
        @Prop() racks!: [];

        tableColumns = [];

        tableOptions = {
            pagination: true,
            pageSize: 25,
          rowStyle: (row) => ({css: {'font-weight': row.count > 0 ? 'bold' : 'normal', 'opacity': row.count > 0 ? 1 : 0.45}})
        }

        created() {
            this.tableColumns = [
                {field: 'rackName', title: this.$i18n.t('stalak')},
                {field: 'difference', width: 50, formatter: ObjektiCard2TabStalci.diffFormatter},
                {field: 'count', width: 30, title: this.$i18n.t('kol')},
            ];
        }

        @Watch('isBusyLoadingRacks') isBusyChange(value) {
          let table = $(this.$refs.table);
          if (value) {
              table.bootstrapTable('showLoading');
          } else {
              table.bootstrapTable('hideLoading');
          }
        }

        private static diffFormatter(value) {
          if (Math.sign(value) > 0) {
            return `${Math.abs(value)} <i class="fa fa-arrow-up text-success"></i>`;
          } else if (Math.sign(value) < 0) {
            return `${Math.abs(value)} <i class="fa fa-arrow-down text-danger"></i>`;
          }
          return "";
        }
    }
